import React, { memo, useCallback, useRef } from "react"
import styled from "styled-components"
import { ScrollTrigger, useGSAP } from "@/utils/gsap"
import Icon from "@/components/common/Icon/Icon"
import { ICONS } from "@/constants"
import useIsomorphicLayoutEffect from "@/hooks/useIsomorphicLayoutEffect"
import { setCssVars } from "@/utils/utils"
import useScrollContext from "@/hooks/useScrollContext"
import { useViewportHeight } from "@/hooks/useViewport"

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	//border: solid 1px crimson;;
	//padding: 10px;
	z-index: 10;
	//row-gap: 1px;
	//transform: translateY(-50%);
`
const Line = styled.span`
	--gap: 8px;
	--height: 3px;
	position: relative;
	display: flex;
	height: 11px;
	transition: scale var(--rgr-duration) var(--ease);
	width: 24px;
	cursor: pointer;

	&.highlight {
		scale: 1 2;
	}

	&:after {
		content: " ";
		position: absolute;
		inset: calc(var(--gap) / 2) 0;
		background-color: ${({ theme }) => theme.colors.periwinkle};
	}
`

const Triangle = styled(Icon)`
	--index: 0;
	--base-y: -1px;
	max-width: 13px;
	position: absolute;
	left: -8px;
	translate: -100% calc(var(--base-y) + (var(--index) * 11px));
	transition: translate var(--rgr-duration) var(--ease);
`
const PinSpacer = styled.div`
	height: 100%;
`
const Pointer = ({ currIndex = 0 }) => {
	const TriangleRef = useRef()

	useIsomorphicLayoutEffect(() => {
		// console.log(currIndex);
		setCssVars(TriangleRef.current, { index: currIndex })
	}, [currIndex])

	return <Triangle ref={TriangleRef} name={ICONS.TRIANGLE} />
}
const Elevator = ({ items = [], currIndex = 0, className = "", ...props }) => {
	const ElevatorRef = useRef()
	const SpacerRef = useRef()
	const data = Array.isArray(items) ? items : []
	const scroll = useScrollContext()
	const viewportHeight = useViewportHeight()

	const onLineClick = useCallback(
		(index) => {
			const item = items[index]
			const domItem = document.getElementById(item.id)
			const offset = viewportHeight * 0.12 - 2
			scroll.scrollTo({
				top: window.scrollY + domItem.getBoundingClientRect().top - offset,
				behavior: "smooth",
			})
		},
		[viewportHeight, items],
	)

	useGSAP(
		() => {
			//PinSpacer was necessary to prevent animation reset on domNode rerender
			//thus double parent
			const parent = ElevatorRef.current.parentNode.parentNode
			if (!parent) return
			const elevatorBounds = ElevatorRef.current.getBoundingClientRect()
			const end = `center+=${elevatorBounds.height}px` //elevator bottom
			const start = "50%"
			// const end = '50%'
			ScrollTrigger.create({
				trigger: parent,
				// markers: true,
				pin: ElevatorRef.current,
				pinSpacer: SpacerRef.current,
				// pinSpacing: false,
				invalidateOnRefresh: true,
				start: `top ${start}`,
				end: `bottom ${end}`,
			})
		},
		{
			dependencies: [],
			revertOnUpdate: true,
		},
	)

	return (
		<PinSpacer ref={SpacerRef}>
			<Wrapper ref={ElevatorRef} className={`${className}`} {...props}>
				<Pointer currIndex={currIndex} />
				{data.map((item, index) => {
					return <Line key={index} onClick={() => onLineClick(index)} />
				})}
			</Wrapper>
		</PinSpacer>
	)

	// return (
	// 	<Wrapper ket ref={ElevatorRef} className={`${className}`} {...props}>
	// 		<Pointer currIndex={currIndex}/>
	// 		{data.map((item, index) => {
	// 			return (
	// 				<Line key={index} className={``}/>
	// 			)
	// 		})}
	// 	</Wrapper>
	// );
}

export default memo(Elevator)
